// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1uVP-","actionsCol":"EnrolledClinics_actionsCol__2Qidv"};